interface AttendanceEmployeeCardProps {
  name: string
  designation: string
  employeeId: string
  department: string
}

function getInitials(name: string): string {
  const parts = name.trim().split(' ')
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

export function AttendanceEmployeeCard({
  name,
  designation,
  employeeId,
  department,
}: AttendanceEmployeeCardProps) {
  return (
    <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 flex items-center gap-3.5 min-w-0">
      <div className="w-11 h-11 rounded-full bg-[#146971] text-white flex items-center justify-center font-bold text-sm shrink-0">
        {getInitials(name)}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-base font-bold text-slate-900 truncate">{name}</div>
        <div className="text-xs mt-0.5 flex items-center gap-1.5 flex-wrap">
          <span className="font-bold text-[#146971]">{employeeId}</span>
          <span className="text-slate-400">•</span>
          <span className="text-slate-500 font-medium">{department}</span>
        </div>
        <div className="text-xs text-slate-500 mt-0.5">{designation}</div>
      </div>
    </div>
  )
}
